<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
    <template v-if="isOfferRedeemed">
      <span class="cf-icon cf-icon--brand-primary cf-icon--large far fa-check-circle" />

      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <h2 class="cf-title cf-title--2">
          Offer Redeemed!
        </h2>

        <p class="cf-subtitle cf-subtitle--2">
          This offer has been successfully redeemed and the discount was applied to your check.
        </p>
      </div>

      <button
        type="button"
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        @click="$closeModal('offerInStoreRedemption')"
      >
        Okay
      </button>
    </template>

    <template v-else>
      <h2 class="cf-title cf-title--2">
        {{ redemptionContent.scanInstructions }}
      </h2>

      <cf-loading-wrapper
        :is-loading="isLoadingRedemptionCode"
        :loader-type="'section'"
      >
        <div class="cf-qr-code-container">
          <vue-qrcode
            v-if="isQrCodeDisplayEnabled"
            class="cf-image cf-image--auto-w cf-image--border"
            :value="offerRedemptionCode"
            :scale="7"
          />
        </div>
      </cf-loading-wrapper>

      <div v-if="isRedemptionCodeDisplayEnabled">
        <h3 class="cf-title cf-title--3">
          {{ redemptionContent.useCodePrefix }}
        </h3>

        <h2 class="cf-title cf-title--2">
          {{ offerRedemptionCode }}
        </h2>
      </div>

      <p
        v-if="codeExpirationDisplayTime"
        class="cf-subtitle cf-subtitle--2 cf-text-align-center"
      >
        {{ redemptionContent.refreshCodePrefix }} <b class="cf-subtitle--heavy">{{ codeExpirationDisplayTime }}</b>
      </p>
    </template>

    <cf-title-separator
      v-if="offer.description"
      :omit-title="true"
    />

    <div
      v-if="offer.description"
      class="cf-flex cf-flex--column cf-flex--gap-12 cf-text-align-left"
    >
      <h3 class="cf-title cf-title--3">
        {{ offer.title }}
      </h3>

      <p class="cf-subtitle cf-subtitle--2">
        {{ offer.description }}
      </p>

      <p
        v-if="offer.endDate"
        class="cf-subtitle cf-subtitle--3 cf-subtitle--heavy cf-text-italics"
      >
        Expires {{ $formatDate(offer.endDate) }}
      </p>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfLoadingWrapper from '@/view/components/globals/cf-loading-wrapper/index.vue';
  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';


  export default {
    name: 'RedeemableOffer',

    components: {
      CfLoadingWrapper,
      CfTitleSeparator
    },

    props: {
      offer: {
        type: Object,
        default() {
          return {};
        }
      },

      offerRedemptionCode: {
        type: String,
        default: ''
      },

      isOfferRedeemed: {
        type: Boolean,
        default: false
      },

      isLoadingRedemptionCode: {
        type: Boolean,
        default: false
      },

      codeExpirationInSeconds: {
        type: Number,
        default: 0
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),

      redemptionContent() {
        const content = this.content.InStoreRedemption;

        return {
          scanInstructions: content.metadata?.codeUsageInstructions || 'To redeem, please show this barcode to the staff',
          useCodePrefix: content.metadata?.codeTextPrefix || 'Use Code:',
          refreshCodePrefix: content.metadata?.refreshCode || 'Code will refresh in:'
        };
      },

      isRedemptionCodeDisplayEnabled() {
        const { displayRedemptionCodeText } = this.merchant.options.offersOptions.inStoreRedemptionOptions;

        return displayRedemptionCodeText;
      },

      isQrCodeDisplayEnabled() {
        const { displayRedemptionQrCode } = this.merchant.options.offersOptions.inStoreRedemptionOptions;

        return displayRedemptionQrCode;
      },

      codeExpirationDisplayTime() {
        if (this.codeExpirationInSeconds === 0) {
          return '0:00';
        }

        const minutes = Math.floor(this.codeExpirationInSeconds / 60);
        const seconds = this.codeExpirationInSeconds - (minutes * 60);
        const secondsPadded = seconds < 10 ? `0${seconds}` : seconds;

        return `${minutes}:${secondsPadded}`;
      }
    }
  };
</script>
